<template>
  <div>
    <JobPostScheduleRegular v-if="showScheduleRegular" />
    <OneTimeSchedule :draft="draft" v-if="showScheduleOneTime" />
    <JobPostScheduleOccasional :draft="draft" v-if="showScheduleOccasional" />
    <JobPostScheduleNanny v-if="showScheduleNanny" />
  </div>
</template>

<script lang="ts">
import JobPostScheduleOccasional from './JobPostScheduleOccasional.vue';
import OneTimeSchedule from './JobPostScheduleOneTime.vue';
import JobPostScheduleRegular from './JobPostScheduleRegular.vue';
import JobPostScheduleNanny from './JobPostScheduleNanny.vue';
import { PropType } from 'vue';
import { JobPostDraft, ScheduleTypes } from '../types';

export default {
  name: 'Schedule',
  components: {
    JobPostScheduleRegular,
    JobPostScheduleOccasional,
    OneTimeSchedule,
    JobPostScheduleNanny,
  },
  props: {
    draft: {
      type: Object as PropType<JobPostDraft>,
      required: true,
    },
  },
  computed: {
    selectedScheduleType(): ScheduleTypes {
      const { scheduleType } = this.draft;

      if (
        scheduleType === ScheduleTypes.REGULAR ||
        scheduleType === ScheduleTypes.ONE_TIME ||
        scheduleType === ScheduleTypes.OCCASIONAL ||
        scheduleType === ScheduleTypes.NANNY
      ) {
        return scheduleType;
      }

      return ScheduleTypes.REGULAR;
    },
    showScheduleRegular(): boolean {
      return this.selectedScheduleType === ScheduleTypes.REGULAR;
    },
    showScheduleOneTime(): boolean {
      return this.selectedScheduleType === ScheduleTypes.ONE_TIME;
    },
    showScheduleOccasional(): boolean {
      return this.selectedScheduleType === ScheduleTypes.OCCASIONAL;
    },
    showScheduleNanny(): boolean {
      return this.selectedScheduleType === ScheduleTypes.NANNY;
    },
  },
};
</script>
